import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 16 9",
  "content": "<symbol viewBox=\"0 0 16 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.707253 7.07112C0.316728 7.46164 0.316728 8.0948 0.707253 8.48533C1.09778 8.87585 1.73094 8.87585 2.12147 8.48533L7.77832 2.82847L13.4352 8.48533C13.8257 8.87585 14.4589 8.87585 14.8494 8.48533C15.2399 8.0948 15.2399 7.46164 14.8494 7.07112L8.48543 0.707154C8.0949 0.31663 7.46174 0.31663 7.07121 0.707154L0.707253 7.07112Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol